<div class="sucesso-container">
  <div class="container-sucesso">
    <div class="sucesso-icone">
      <img
        src="{{
          BASE_IMG_URL
        }}assets/img-ficha-obra/concluido.png"
        alt=""
        alt=""
      />
    </div>
    <div class="sucesso-mensagem">
      {{ mensagem }}
    </div>
  </div>

  <div class="footer-actions">
    <button class="sucesso-botao" type="button" (click)="continuar.emit()">
      {{ botaoTexto }}
    </button>
  </div>
</div>
